<!-----------------------------------------
You can change the Background color of ticket Thread Using the following Class
.light-blue-bg - Blue Bg
.light-green-bg - Grreen Bg
.light-org-bg - Orange Bg
------------------------------------------>

<!-- <input type="hidden" id="refresh_page_reply" (click)="refresh()"> -->

<div style="font-family: Verdana , sans-serif;" class="section-body ticket-thread-view">
	<div class="row">

		<div class="col-12">
			<div class="card">
				<div class="card-header" [ngStyle]="{'background-color': closed ? '#fd030380' : ''}">
					<div *ngIf="closed==false" class="ticket-action-group">
						<div class="ticket-assign-btn">
							<ul>
								<li><a href="javascript:void(0)" class="gradient-btn" (click)="backtoPage()">
										<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32"
											viewBox="0 0 32 32" class="app-icon">
											<path
												d="M6.313 12.929l9.442-9.246c.478-.468.488-1.236.022-1.716s-1.231-.49-1.709-.022L2.499 13.273c-.226.22-.366.529-.366.87s.14.649.366.87l11.569 11.328c.478.468 1.243.458 1.709-.022s.456-1.248-.022-1.716l-9.442-9.246h15.769c2.67 0 4.834 2.174 4.834 4.855v9.508c0 .67.541 1.214 1.209 1.214s1.209-.543 1.209-1.214v-9.508c0-4.022-3.247-7.283-7.252-7.283H6.313z">
											</path>
										</svg>
										Back</a></li>
								<li
									[ngStyle]="ticket_delete_status ? {'pointer-events': 'none', 'filter': 'blur(1px)'} : {}">
									<a (click)="toggleClassreplyall(this.ticket_t)" class="gradient-btn"><svg
											style="transform: rotate(180deg);" xmlns="http://www.w3.org/2000/svg"
											width="32" height="32" viewBox="0 0 32 32" class="app-icon">
											<path
												d="M6.313 12.929l9.442-9.246c.478-.468.488-1.236.022-1.716s-1.231-.49-1.709-.022L2.499 13.273c-.226.22-.366.529-.366.87s.14.649.366.87l11.569 11.328c.478.468 1.243.458 1.709-.022s.456-1.248-.022-1.716l-9.442-9.246h15.769c2.67 0 4.834 2.174 4.834 4.855v9.508c0 .67.541 1.214 1.209 1.214s1.209-.543 1.209-1.214v-9.508c0-4.022-3.247-7.283-7.252-7.283H6.313z">
											</path>
										</svg> Reply</a>
								</li>

								<li [ngStyle]="ticket_delete_status ? {'pointer-events': 'none', 'filter': 'blur(1px)','position': 'absolute','right': '20px'} : {'position': 'absolute','right': '20px'}"
									*ngIf="unmarkspamshow && (this.user_type == 'Admin'||this.admin_permission=='1')"><a
										href="javascript:;" (click)="changetoUnspam()" class="gradient-btn">
										<i class="fas fa-ban"></i> Mark as Not Spam</a></li>
								<li style="position: absolute;right: 220px;" *ngIf="!ticket_delete_status&&showDelete">
									<a href="javascript:;" (click)="DeleteTicket()" class="gradient-btn">
										<i class="far fa-trash-alt"></i> Delete</a>
								</li>
								<li style="position: absolute;right: 218px;" *ngIf="ticket_delete_status"><a
										href="javascript:;" (click)="RestoreTicket()" class="gradient-btn">
										<i class="fas fa-trash-restore"></i> Restore</a></li>

								<li [ngStyle]="ticket_delete_status ? {'pointer-events': 'none', 'filter': 'blur(1px)'} : {}"
									*ngIf="(this.ticket_agent == '' || this.ticket_agent == 'null') && this.user_type =='Employee'">
									<a (click)="PickUpTicket()" class="gradient-btn"><svg
											xmlns="http://www.w3.org/2000/svg" width="32" height="32"
											viewBox="0 0 32 32" class="app-icon">
											<path
												d="M7.822 1.6h16.356c2.258 0 4.089 1.808 4.089 4.038v20.19c0 2.23-1.831 4.038-4.089 4.038H7.822c-2.258 0-4.089-1.808-4.089-4.038V5.638c0-2.23 1.831-4.038 4.089-4.038zm0 2.423c-.903 0-1.636.723-1.636 1.615v20.19c0 .892.732 1.615 1.636 1.615h16.356c.903 0 1.636-.723 1.636-1.615V5.638c0-.892-.732-1.615-1.636-1.615H7.822zm2.234 3.634h11.888a1.21 1.21 0 110 2.422H10.056a1.21 1.21 0 110-2.422zm0 6.865h11.888a1.21 1.21 0 110 2.422H10.056a1.21 1.21 0 110-2.422zm0 6.865h11.888a1.21 1.21 0 110 2.422H10.056a1.21 1.21 0 110-2.422z">
											</path>
										</svg> Pick Up for Myself</a>
								</li>
								<div *ngIf="Reopen_closed==true" style="color: white; float: right; text-align: right;">
									<a class="btn btn-danger" style="width: 40px;font-size: 15px;"
										title="This Ticket has been Reopened"><i class="fas fa-ban"></i> </a>
								</div>
							</ul>
						</div>
					</div>
					<div *ngIf="closed==true" class="ticket-action-group" style="width: 100%;">
						<div class="inbox-header"
							style="display: flex;align-items: center;justify-content: space-between;">
							<h5 style="text-align:center;">Ticket have been closed <span
									style="font-size: 14px;font-weight: 900;color: black;">{{closed_by}}</span> <span
									style="font-size: 14px;font-weight: 900;color: black;"> {{closed_time}} </span>
							</h5>
							<div>
								<a href="javascript:;" (click)="changeMyStatus(this.ticket_t)" class="gradient-btn"><svg
										xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"
										class="app-icon">
										<path
											d="M24.403 3.003a1.2 1.2 0 01-1.301 2.017c-5.13-3.31-11.989-2.627-16.349 1.734-5.084 5.084-5.084 13.41 0 18.494s13.41 5.084 18.494 0c2.779-2.779 4.118-6.62 3.755-10.487a1.2 1.2 0 112.39-.224c.429 4.571-1.156 9.118-4.447 12.409-6.021 6.021-15.867 6.021-21.889 0s-6.021-15.867 0-21.889C10.221-.108 18.328-.915 24.403 3.004zM10.47 14.64l4.244 4.467 12.73-11.981a1.2 1.2 0 011.645 1.747l-13.6 12.8a1.2 1.2 0 01-1.692-.047L8.73 16.293a1.201 1.201 0 011.74-1.654z">
										</path>
									</svg> Reopen</a>
								<a href="javascript:void(0)" class="gradient-btn" (click)="backtoPage()">
									<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"
										class="app-icon">
										<path
											d="M6.313 12.929l9.442-9.246c.478-.468.488-1.236.022-1.716s-1.231-.49-1.709-.022L2.499 13.273c-.226.22-.366.529-.366.87s.14.649.366.87l11.569 11.328c.478.468 1.243.458 1.709-.022s.456-1.248-.022-1.716l-9.442-9.246h15.769c2.67 0 4.834 2.174 4.834 4.855v9.508c0 .67.541 1.214 1.209 1.214s1.209-.543 1.209-1.214v-9.508c0-4.022-3.247-7.283-7.252-7.283H6.313z">
										</path>
									</svg>
									Back</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="col-xs-12 col-sm-12 col-xl-9">
			<div class="card">
				<div class="boxs mail_listing">
					<div class="row">
						<div class="ticket-header composeForm" style="padding:25px">
							<div class="message-thread-panel no-margin-bottom light-blue-bg fl">
								<div class="message-thread-header">
									<div class="row">
										<div class="col-md-9">
											<div class="thread-details-section fl">
												<div style="padding: 5px 25px;" class="ticket-message-details fl">
													<strong style="min-width: 72px; float: left;">Subject</strong>
													<span style="text-align: center;">
														<span class="blk-clr"><b>: &nbsp;&nbsp;
																{{this.tick_subject}}</b></span>
													</span>
												</div>
											</div>
										</div>
										<div class="col-lg-3">
											<div style="padding: 3px 7px;" class="ticket-message-details fl"><strong
													style="min-width: 72px; float: left;">Status</strong>
												<span style="text-align: center;">
													<span style="color: #3d77a7; font-weight: 700;"><b>: &nbsp;&nbsp;
															{{this.ticket_status}}</b></span>
												</span>
											</div>
										</div>
									</div>
								</div>
								<div class="message-thread-body fl">
									<div class="row">
										<div class="col-lg-9">
											<div class="ticket-message-details fl"><strong
													style="min-width: 72px; float: left;">From</strong>
												<span style="text-align: center;">
													<span class="blk-clr"><b>:
															&nbsp;&nbsp; {{this.tick_from}}</b></span>
													<span *ngIf="this.ticket_created_by == 'user'">: &nbsp;&nbsp;
														{{this.tick_from}}</span>
												</span>

											</div>
										</div>
										<div class="col-lg-3">
											<div style="padding: 5px 25px;" class="ticket-message-details fl"><strong
													style="min-width: 72px; float: left;">Ticket ID</strong>
												<span style="text-align: center;">
													<span style="color: #3d77a7; font-weight: 700;"><b>: &nbsp;&nbsp;
															#{{this.ticket_id_orginal}}</b></span>
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="card margin-15" id="replyPanelall_{{this.ticket_t}}"
							style="display: none; width: 100%;">
							<div class="boxs mail_listing">
								<div class="row">
									<div class="col-lg-12">
										<div class="composeForm">
											<!-- <h6><span class="blk-clr"></span></h6>
											<p><strong>{{this.tick_subject}}</strong></p> -->
											<!-- <div class="form-group">
												<label><b>To</b></label>
												<div class="form-line">
													<mat-form-field class="email-chip-list">
														<mat-chip-list #chipListTO aria-label="EmailAddress selection">
															<mat-chip
																*ngFor="let EmailAddress of EmailToAddress;let i=index"
																[selectable]="selectable" [removable]="removable"
																(removed)="removeTo(EmailAddress)">
																{{EmailAddress.email_to}}
																<mat-icon matChipRemove *ngIf="removable">cancel
																</mat-icon>
															</mat-chip>


															<input class="form-control" placeholder="Add Receiver Email"
																[matChipInputFor]="chipListTO"
																[matChipInputSeparatorKeyCodes]="separatorKeysCodes"
																[matChipInputAddOnBlur]="addOnBlur"
																(matChipInputTokenEnd)="addTo($event)">
														</mat-chip-list>
													</mat-form-field>
												</div>
											</div> -->
											<form [formGroup]="replytextmessage">
												<div class="form-group">
													<div class="form-line">
														<label><b>Subject</b></label>
														<input disabled type="text" id="subject_{{this.ticket_t}}"
															class="form-control" formControlName="subject"
															value='{{this.tick_subject}}' placeholder="Subject">
													</div>
												</div>
											</form>
											<div class="form-group">
												<label for="subject">Message</label>
												<textarea class="form-control" id="richTextAreaReply"
													(keydown)="onMessageSend($event)" #chat_message></textarea>
											</div>
											<div class="form-group">
												<label>File Upload </label>
												<div class="uploadfilecontainer" (click)="fileInput.click()" appDragDrop
													(onFileDropped)="uploadFiless($event)">
													<input hidden type="file" #fileInput (change)="uploadFile($event)">
												</div>
												<div class="files-list" *ngFor="let file of files;let i= index">
													<p> {{ file }} </p>
													<button class="delete-file" (click)="deleteAttachment(i)">
														<a href="javascript:;" data-toggle="tooltip" title="View"
															class="btn btn-danger">
															<i class="far fa-trash-alt"></i>
														</a>
													</button>
												</div>
											</div>
										</div>
									</div>
									<div class="col-lg-12">
										<div class="m-l-25 m-b-20">
											<button *ngIf="this.ticket_to == this.own_mail" type="button"
												(click)="replyMessage(this.ticket_t,this.replied_from,'s')"
												class="btn btn-success btn-border-radius waves-effect">Send</button>
											<button *ngIf="this.ticket_to != this.own_mail" type="button"
												(click)="replyMessage(this.ticket_t,this.ticket_to,'s')"
												class="btn btn-success btn-border-radius waves-effect">Send</button>
											&nbsp;&nbsp;

											<button type="button" class="btn btn-danger btn-border-radius waves-effect"
												(click)="clickDiscard(this.ticket_t)">Discard</button>
										</div>
									</div>
								</div>
							</div>
						</div>
                        <div #conversationContainer class="conversation-container">
							<ng-container *ngFor="let replies of ticketConversation;let i=index;trackBy: trackByMessageId">
								<div class="col-lg-12" *ngIf="!replies.isHidden">
									<div class="composeForm">

										<div class="card margin-15" id="replyPanel_{{replies.ticket_message_id}}"
											style="display: none;">
											<div class="boxs mail_listing">
												<div class="row">
													<div class="col-lg-12">
														<div class="composeForm">
															<h6><span class="blk-clr"></span></h6>
															<p><strong>#{{this.ticket_t}}</strong></p>
															<div class="form-group">
																<div class="form-line">
																	<input type="text"
																		id="email_address_{{replies.ticket_message_id}}"
																		value='{{replies.replied_from}}'
																		class="form-control" placeholder="TO">
																</div>
															</div>
															<div class="form-group">
																<div class="form-line">
																	<input type="text"
																		id="subject_{{replies.ticket_message_id}}"
																		class="form-control" value='{{this.tick_subject}}'
																		placeholder="Subject">
																</div>
															</div>

															<label for="subject">Message</label>
															<div class="compose-editor m-t-20">
																<div id="summernote"></div>
																<input type="file" class="default"
																	id="up_files_{{replies.ticket_message_id}}"
																	name="up_files" multiple>
															</div>
														</div>
													</div>
													<div class="col-lg-12">
														<div class="m-l-25 m-b-20">

															<button *ngIf="replies.ticket_to == replies.own_mail"
																type="button"
																(click)="replyMessage(replies.ticket_message_id,replies.replied_from,'')"
																class="btn btn-success btn-border-radius waves-effect">Send</button>
															<button *ngIf="replies.ticket_to != replies.own_mail"
																type="button"
																(click)="replyMessage(replies.ticket_message_id,replies.ticket_to,'')"
																class="btn btn-success btn-border-radius waves-effect">Send</button>
															&nbsp;&nbsp;

															<button type="button"
																class="btn btn-danger btn-border-radius waves-effect">Discard</button>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div *ngIf="replies.ticket_forward_by !=null && replies.ticket_forward_by !=''">
											<div *ngFor="let item of replies.ticket_forward_by.reverse()">
												<div style="background-color: #6af17a4f;" class='message-thread-panel  fl'>
													<div class="message-thread-header">
														<div class="row">
															<div class="col-md-11">
																<div class="thread-details-section fl">
																	<div class="ticket-details fl">
																		<ul class="ticket-thread-header-details">
																			<li>
																				<div class="agent-name">
																					<div
																						class="round-block light-green-bg d-flex">
																						<img src="{{item.profile_image}}"
																							onerror="src='assets/images/user.jpg'">
																					</div>
																				</div>
																			</li>
																			<li>
																				<h6><span
																						class="blk-clr">{{item.created_name}}</span>
																					sent a entire thread to <span
																						class="blk-clr">{{item.forward_to}}</span>
																					at <small><i>
																							{{item.created_dt}}</i></small>
																				</h6>
																			</li>
																		</ul>
																	</div>

																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div *ngIf="replies.ticket_notes !=null">
											<div *ngFor="let item of replies.ticket_notes.reverse()">
												<div class='message-thread-panel light-org-bg fl'>
													<div class="message-thread-header">
														<div class="row">
															<div class="col-md-11">
																<div class="thread-details-section fl">

																	<div class="ticket-details fl">

																		<ul class="ticket-thread-header-details">
																			<li>
																				<div class="agent-name">
																					<div
																						class="round-block light-green-bg d-flex">
																						<img src="{{item.profile_image}}"
																							onerror="src='assets/images/user.jpg'">
																					</div>
																				</div>
																			</li>
																			<li>
																				<h6><span
																						class="blk-clr">{{item.created_name}}</span>
																					added a private note at <small><i>
																							{{item.created_dt}}</i></small>
																				</h6>
																			</li>
																		</ul>
																	</div>
																</div>
															</div>
														</div>
													</div>

													<div class="message-thread-body fl">
														<div class="row">
															<div class="col-xl-12">
																<div [innerHTML]="item.ticket_notes"></div>
															</div>
														</div>
													</div>

												</div>
											</div>
										</div>
										<!-- ============================= -->
										<!-- SYSTEM EVENT -->
										<!-- ============================= -->

										<div class="ticket-system-event" *ngIf="replies.repliesd_by === 'System'">

											<div class="system-event-line">

												<span class="system-event-dot" [ngClass]="{
												'open-dot': replies.status_message.includes('Open'),
												'new-dot': replies.status_message.includes('New'),
												'progress-dot': replies.status_message.includes('Progress'),
												'default-dot':
												!replies.status_message.includes('Open') &&
												!replies.status_message.includes('New') &&
												!replies.status_message.includes('Progress')
											}"></span>

												<span class="system-event-text">
													{{ replies.status_message }}
												</span>

												<span class="system-event-date">
													{{ replies.created_dt }}
												</span>

											</div>

										</div>
										<div class='message-thread-panel fl light-blue-bg customer-message'
											*ngIf="replies.repliesd_by == 'Customer'">
											<div class="message-thread-header light-blue-bg"
												style="background-color: #a6bcd2;">
												<div class="row">
													<div class="col-md-11">
														<div class="thread-details-section fl">
															<div class="ticket-details fl">
																<ul class="ticket-thread-header-details">
																	<li>
																		<div class="agent-name">
																			<div class="d-flex">
																				<div *ngIf="this.customer_profile==''"
																					class="round-block bg-1 d-flex pointer">
																					{{getShortName(replies.replied_from)}}
																				</div>
																				<div *ngIf="this.customer_profile!=''">
																					<img src="{{this.customer_profile}}">
																				</div>
																			</div>
																		</div>
																	</li>
																	<li style="display: block;width: 100%;">
																		<h6><span
																				class="blk-clr">{{replies.replied_from}}</span>
																			added comment at
																			<small><i>{{replies.created_dt}}</i></small>
																		</h6>

																	</li>
																</ul>
															</div>
														</div>
													</div>
												</div>
											</div>

											<div class="message-thread-body fl">
												<div class="row">
													<div class="col-xl-12">
														<div [innerHTML]="replies.ticket_message | safe: 'html'"
															style="font-family:Verdana">
														</div>
													</div>
												</div>
											</div>
											<div>
												<div class="message-thread-attachment fl"
													*ngIf="replies.ticket_media != null && replies.ticket_media[0] !=''">
													<div class="row">
														<div class="" style="margin: 0px 10px;"
															*ngFor="let item of replies.ticket_media;let i=index">
															<div class="attached-file-type">
																<img *ngIf="this.getFileExtension(item)=='docx'"
																	src="assets/images/icons/docx.svg">
																<img *ngIf="this.getFileExtension(item)=='pdf'"
																	src="assets/images/icons/pdf.svg">
																<img *ngIf="this.getFileExtension(item)=='xlsx'"
																	src="assets/images/icons/csv.png">
																<img *ngIf="this.getFileExtension(item)=='csv'"
																	src="assets/images/icons/csv.png">
																<img *ngIf="this.getFileExtension(item)==''||(this.getFileExtension(item)!='docx' && this.getFileExtension(item)!='pdf' && this.getFileExtension(item)!='png' && this.getFileExtension(item)!='xlsx' && this.getFileExtension(item)!='csv' && this.getFileExtension(item)!='jpeg' && this.getFileExtension(item)!='jpg')"
																	src="assets/images/icons/file.png">
																<div *ngIf="this.getFileExtension(item) !='png' && this.getFileExtension(item) !='jpg' && this.getFileExtension(item) !='jpeg'"
																	class="downlaod-icon">
																	<a href="{{item}}" target="_blank" download>
																		<i class="fas fa-download"></i>
																	</a>
																</div>
																<a *ngIf="this.getFileExtension(item)=='jpeg'"
																	data-fancybox="gallery" href="{{item}}">
																	<img src="{{item}}" width="100%">
																</a>
																<a *ngIf="this.getFileExtension(item)=='jpg'"
																	data-fancybox="gallery" href="{{item}}">
																	<img src="{{item}}" width="100%">
																</a>
																<a *ngIf="this.getFileExtension(item)=='png'"
																	data-fancybox="gallery" href="{{item}}">
																	<img src="{{item}}" width="100%">
																</a>
															</div>

														</div>
													</div>
												</div>
											</div>
										</div>
										<div class='message-thread-panel agent-reply-panel fl light-green-bg'
											*ngIf="replies.repliesd_by == 'Agent'">
											<div class="message-thread-header light-green-bg">
												<div class="row">
													<div class="col-md-1"></div>
													<div class="col-md-11 agent-opt">
														<div class="thread-details-section fl">
															<div class="ticket-details fr">
																<ul class="ticket-thread-header-details">
																	<li>
																		<h6>
																			<!-- <span *ngIf="replies.rep_name ==null" -->
																				<span class="blk-clr">{{ replies.agent_name }} </span>
																			added comment at
																			<small><i>{{replies.created_dt}}</i></small>
																		</h6>


																	</li>
																	<li>
																		<div class="agent-name">
																			<div class="d-flex">
																				<img *ngIf="replies.profile_image != null"
																					src="{{replies.profile_image}}"
																					onerror="this.src='assets/images/user.jpg'"
																					alt="avatar" />
																				<img *ngIf="replies.profile_image == null"
																					src="{{replies.own_img}}"
																					onerror="this.src='assets/images/user.jpg'"
																					alt="avatar" />

																			</div>

																		</div>
																	</li>
																</ul>
															</div>

														</div>
													</div>
												</div>
											</div>

											<div class="message-thread-body fl">
												<div class="row">
													<div class="col-xl-12">
														<div [innerHTML]="replies.only_message | safe: 'html'"
															style="font-family:Verdana">
														</div>
														<div id="accordion_{{replies.ticket_message_id}}">
															<a *ngIf="replies.ticket_only_signature" title="Signature"
																data-toggle="collapse" style="cursor:pointer"
																href="#signature_{{replies.ticket_message_id}}">
																...
															</a>
															<a id="signature_{{replies.ticket_message_id}}" class="collapse"
																href="#accordion_{{replies.ticket_message_id}}">
																<div
																	[innerHTML]="replies.ticket_only_signature| safe: 'html'">
																</div>
															</a>
														</div>
													</div>
												</div>
											</div>
											<div>

												<div class="message-thread-attachment fl"
													*ngIf="replies.ticket_media != null && replies.ticket_media[0] !=''">
													<div class="row">
														<div class="" style="margin: 0px 10px;"
															*ngFor="let item of replies.ticket_media;let i=index">
															<div class="attached-file-type">
																<img *ngIf="this.getFileExtension(item)=='docx'"
																	src="assets/images/icons/docx.svg">
																<img *ngIf="this.getFileExtension(item)=='pdf'"
																	src="assets/images/icons/pdf.svg">
																<img *ngIf="this.getFileExtension(item)=='xlsx'"
																	src="assets/images/icons/csv.png">
																<img *ngIf="this.getFileExtension(item)=='csv'"
																	src="assets/images/icons/csv.png">
																<img *ngIf="this.getFileExtension(item)==''||(this.getFileExtension(item)!='docx' && this.getFileExtension(item)!='pdf' && this.getFileExtension(item)!='png' && this.getFileExtension(item)!='xlsx' && this.getFileExtension(item)!='csv' && this.getFileExtension(item)!='jpeg' && this.getFileExtension(item)!='jpg')"
																	src="assets/images/icons/file.png">
																<div *ngIf="this.getFileExtension(item) !='png' && this.getFileExtension(item) !='jpg' && this.getFileExtension(item) !='jpeg'"
																	class="downlaod-icon">
																	<a href="{{item}}" target="_blank" download>
																		<i class="fas fa-download"></i>
																	</a>
																</div>
																<a *ngIf="this.getFileExtension(item)=='jpeg'"
																	data-fancybox="gallery" href="{{item}}">
																	<img src="{{item}}" width="100%">
																</a>
																<a *ngIf="this.getFileExtension(item)=='jpg'"
																	data-fancybox="gallery" href="{{item}}">
																	<img src="{{item}}" width="100%">
																</a>
																<a *ngIf="this.getFileExtension(item)=='png'"
																	data-fancybox="gallery" href="{{item}}">
																	<img src="{{item}}" width="100%">
																</a>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>

									</div>
								</div>
							</ng-container>
						</div>
					</div>

					<div *ngIf="showmore_button==true" class="more-ticket-thread">
						<button class="more-block" (click)="showmore()">
							<div class="more-conversation-icon">
								<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
									class="app-icon" data-identifyElement="1820">
									<path fill-rule="evenodd"
										d="M8.987 18.999L0 10.1l1.428-1.415 7.56 7.485V0h2.02v16.176l7.564-7.49L20 10.101 10.002 20 10 19.998 9.998 20l-1.01-1v-.001z"
										data-identifyElement="1821"></path>
								</svg>
							</div>
							<span class="pt-1 pb-1 ml-6 more-conversation-text">
								<span class="more-count">
									{{ conversation_show ? 'Show Less' : 'Show More' }}</span>
							</span>
						</button>
					</div>

				</div>
			</div>
		</div>

		<div class="col-xs-12 col-sm-12 col-xl-3">
			<div class="card fixedTop" id="fixedTop">
				<div class="body padding-15">
					<div id="mail-nav">
						<p class="mail-title"><b>PROPERTIES</b></p>
						<ul class="ticket-reply-action-group">
							<li>
								<div class="form-group">
									<label>Status - <b>{{this.ticket_status}}</b></label>
									<input type="text" [(ngModel)]="ticket_status" id="ticket_status"
										class="form-control" readonly>
								</div>
							</li>
							<li>
								<div class="form-group">
									<label>Agent <b *ngIf="this.ticket_agent_name != ''"> - Assigned</b></label>
									<input type="text" *ngIf="this.ticket_agent_name == ''" value="Not assigned"
										class="form-control" readonly>
									<input type="text" *ngIf="this.ticket_agent_name != ''"
										[(ngModel)]="ticket_agent_name" id="agent_options" class="form-control"
										readonly>
								</div>
							</li>
							<li>
								<div class="form-group">
									<label>Country </label>
									<input type="text" [(ngModel)]="ticket_agent_country" id="agent_options"
										class="form-control" readonly>
								</div>
							</li>
							<li>
								<div class="form-group">
									<label>Priority </label>
									<input type="text" [(ngModel)]="ticket_agent_priority" id="agent_options"
										class="form-control" readonly>
								</div>
							</li>
							<li>
								<div class="form-group">
									<label>Request Type </label>
									<input type="text" [(ngModel)]="ticket_agent_requestType" id="agent_options"
										class="form-control" readonly>

								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div class="modal fade bd-example-modal-xl" id="userDepartmentManagement">
			<div class="modal-dialog modal-xl">
				<div class="modal-content">
					<div class="modal-body">
						<div id="accordion" class="accordion">
							<div class="card mb-0">
								<div class="card-header show" data-toggle="collapse" href="#collapseOne">
									<h4>Click to Add Private Notes</h4>
								</div>
								<div id="collapseOne" class="card-body collapse show" data-parent="#accordion">
									<div class="modal-body">
										<label>Here is the Private note for <b>TicketID #{{this.ticket_t}}</b> </label>
										<textarea class="form-control" id=privateNote> </textarea>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<div class="buttons">
							<input type="button" data-dismiss="modal" class="btn btn-outline-secondary" value="Cancel">
							<input type="button" class="btn btn-success update_agent" value="Submit"
								(click)="AddNote()">
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<div style="font-family: Verdana , sans-serif;" class="modal fade bd-example-modal-xl" id="showpop_signature">
	<div class="modal-dialog modal-xl">
		<div class="modal-content">
			<div class="modal-body">
				<div id="accordion" class="accordion">
					<div class="card mb-0">
						<div class="card-header show" data-toggle="collapse" href="#collapseOne">
							<h4>View Signature Details</h4>
						</div>
						<div id="collapseOne" class="card-body collapse show" data-parent="#accordion">
							<div class="modal-body">
								<div class="col-md-12">
									<div class="thread-details-section fl">
										<div style="padding: 5px 25px;" class="ticket-message-details fl">
											<span style="text-align: center;">
												<h5 class="modal-title mb-0">{{this.signature_title}}</h5>
											</span>
										</div>
									</div>
								</div>
								<div class="col-md-12">
									<div class="thread-details-section fl">
										<div style="padding: 5px 25px;" class="ticket-message-details fl">
											<div [innerHTML]="this.signature_content| safe: 'html'"></div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<div class="buttons">
					<input type="button" data-dismiss="modal" class="btn btn-outline-secondary" value="close">
				</div>
			</div>
		</div>
	</div>
</div>

<div class="modal fade bd-example-modal-lg" id="send_thread_modal">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<form>
				<div class="modal-header">
					<h5 class="modal-title" id="myLargeModalLabel">Forward Full Email Thread</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<span *ngIf="show_email_errors"
								style="margin: 10px;color: #ff0000d4;font-weight: 600;">{{email_error_msg}} </span>
						</div>
					</div>
				</div>

				<div class="modal-footer">
					<div class="buttons">
						<input type="button" (click)="clearEmailform()" data-dismiss="modal"
							class="btn btn-outline-secondary" value="Cancel">
						<input type="submit" (click)="sendFullThread()" class="btn btn-primary update_agent"
							value="Send Thread">
					</div>
				</div>
			</form>
		</div>
	</div>
</div>